import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CenterContainer, Overlay, PopupWindow } from '../shared/PopupComponents';
import { routes } from '../../data/routes';
import { AdamaraLogo } from '../shared/AdamaraLogo';
import { Link } from 'react-router-dom';
import { resourcePublicModuleInMenu } from '../../communication/api';
import { PublicMenuModuleSelection } from './PublicMenuModuleSelection';
import { LoadingSpinnerBlack } from '../shared/LoadingSpinner';
import { FloatingLanguageSwitcher } from '../editor/FloatingLanguageSwitcher';
const Center = styled.div.withConfig({
  displayName: "PublicMenu__Center",
  componentId: "sc-16riw91-0"
})(["text-align:center;"]);
const ErrorText = styled.div.withConfig({
  displayName: "PublicMenu__ErrorText",
  componentId: "sc-16riw91-1"
})(["color:red;"]);
const StyledPopupWindow = styled(PopupWindow).withConfig({
  displayName: "PublicMenu__StyledPopupWindow",
  componentId: "sc-16riw91-2"
})(["min-width:min(95%,750px);"]);
export const PublicMenu = () => {
  const {
    t
  } = useTranslation();
  const [modules, setModules] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    resourcePublicModuleInMenu().then(modules => setModules(modules)).catch(error => setError(error.toString()));
  }, []);

  if (!modules && !error) {
    return /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(LoadingSpinnerBlack, null)), /*#__PURE__*/React.createElement(FloatingLanguageSwitcher, null));
  }

  return /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(StyledPopupWindow, null, /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(AdamaraLogo, null)), error && /*#__PURE__*/React.createElement(ErrorText, null, error), modules && /*#__PURE__*/React.createElement(PublicMenuModuleSelection, {
    modules: modules
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Link, {
    to: routes.home
  }, t("editor.go_to_editor"))))), /*#__PURE__*/React.createElement(FloatingLanguageSwitcher, null));
};